import React from 'react';

const ConfirmationPopup = ({ message, onConfirm, onCancel }) => {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-2xl shadow-xl w-[90%] max-w-md p-6 text-center">
                <div className="flex items-center justify-center w-20 h-20 mx-auto bg-[#FF0000] text-white rounded-full text-6xl font-bold mb-4">
                    ?
                </div>
                <p className="text-lg font-medium text-gray-800 mb-6">{message}</p>
                <div className="flex justify-between px-20">
                    <button
                        className="px-4 py-2 rounded-lg border-2 font-bold text-[#FF0000] border-[#FF0000]  hover:bg-gray-100 transition duration-200"
                        onClick={onCancel}
                    >
                        Cancel
                    </button>
                    <button
                        className="px-7 py-2 rounded-lg bg-[#FF0000] text-white hover:bg-[#FF0000] transition duration-200"
                        onClick={onConfirm}
                    >
                        Yes
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationPopup;